import { fork } from 'redux-saga/effects'

import * as watchers from './common-watchers'

export default [
  fork(watchers.watchCommonScrollPage),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/common/index.js
 **/